'use client';

import { useRouter } from 'next/navigation';

import { Container } from '@/app/components/layouts/container';
import { PaginationNumber } from '@/app/components/navigation/pagination/pagination-number';
import { OffersGrid } from '@/app/components/sections/special-offer/listing/offers-grid';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { SpecialOffer } from '@/types/special-offer';

export interface SpecialOfferPagedContentProps {
  entries: SpecialOffer[];
  total: number;
  totalPages: number;
  currentPage: number;
  pageBaseUrl: string;
  currentCategory?: string;
}

export const SpecialOfferPagedContent = ({
  entries,
  total,
  totalPages,
  currentPage,
  pageBaseUrl,
  currentCategory,
}: SpecialOfferPagedContentProps) => {
  const router = useRouter();

  const handlePageChange = (page: number) => {
    router.push(page <= 1 ? pageBaseUrl : `${pageBaseUrl}/page/${page}`);
    window.scrollTo(0, 0);
  };

  return (
    <Container
      className="relative"
      {...createDataAttributes({ test: 'section-special-offer-listing' })}
    >
      <OffersGrid entries={entries} currentCategory={currentCategory} />

      <div className="my-10 xl:my-14">
        {totalPages > 1 && (
          <PaginationNumber
            wrapperClassName="justify-center"
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={total}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </Container>
  );
};
